import { ErrorHandler, Injectable, Injector, inject } from '@angular/core';
import { ErrorHandlingService } from './error-handling.service';

/**
 * Manejador global de errores para capturar errores no manejados en la aplicación,
 * especialmente fallos al cargar chunks/módulos dinámicos (lazy loading) por falta de internet.
 */
@Injectable({
  providedIn: 'root'
})
export class GlobalErrorHandler implements ErrorHandler {
  private readonly injector = inject(Injector);

  handleError(error: any): void {
    const errorString = String(error?.message || error);

    // Detectar fallas de carga de módulos dinámicos (lazy loading) por falta de conexión
    if (
      errorString.includes('Failed to fetch dynamically imported module') ||
      errorString.includes('Loading chunk')
    ) {
      console.warn('[GlobalErrorHandler] Error de conexión al cargar módulo dinámico:', error);
      
      try {
        const errorHandlingService = this.injector.get(ErrorHandlingService);
        errorHandlingService.showNetworkAlert();
      } catch (err) {
        // Fallback si falla la inyección
        alert('No se pudo establecer conexión con el servidor. Por favor, verifique su conexión a internet o el estado de la red');
      }

      // Actualizar la página después de que se cierre la alerta
      window.location.reload();
      return;
    }

    // Para otros errores no manejados, imprimirlos en la consola
    console.error('[GlobalErrorHandler] Error no manejado:', error);
  }
}
